module.exports = __webpack_public_path__ + "img/noZutai.756af60d.png";